import { Button } from '@finn/design-system/atoms/button';
import { If } from '@finn/design-system/atoms/If';
import { InfoFilled } from '@finn/design-system/icons/info-filled';
import {
  BannerModule,
  BannerModuleDescription,
  BannerModuleTitle,
} from '@finn/design-system/modules/BannerModule';
import { cn, parseToHtml } from '@finn/ui-utils';

type InfoboxProps = {
  title?: string;
  description?: string;
  cta_text?: string;
  cta_href?: string;
  variant?: string;
  move_up?: string;
  move_down?: string;
};

export const Infobox = ({
  title,
  description,
  variant,
  cta_text,
  cta_href,
  move_up,
  move_down,
}: InfoboxProps) => {
  return (
    <BannerModule
      className={cn(
        'container sm:w-[calc(100%-2rem)] md:w-[calc(100%-1rem)] md:max-w-[726px] lg:relative',
        variant === 'dark' && '!bg-black'
      )}
      style={{
        marginTop: move_up ? move_up : undefined,
        marginBottom: move_down ? move_down : undefined,
      }}
    >
      <If condition={Boolean(title)}>
        <BannerModuleTitle
          asChild
          className={cn(
            'flex items-center gap-2 before:hidden after:hidden',
            variant === 'dark' ? 'text-white' : 'text-black'
          )}
        >
          <h4 style={{ fontSize: '1.125rem' }}>
            <InfoFilled
              className={variant === 'dark' ? 'fill-white' : 'fill-black'}
            />
            {parseToHtml(title)}
          </h4>
        </BannerModuleTitle>
      </If>
      <If condition={Boolean(description)}>
        <BannerModuleDescription
          className={cn(
            '!body-16-light',
            variant === 'dark' ? 'text-white' : 'text-black'
          )}
        >
          {parseToHtml(description)}
        </BannerModuleDescription>
      </If>
      <If condition={Boolean(cta_text && cta_href)}>
        <Button href={cta_href}>{cta_text}</Button>
      </If>
    </BannerModule>
  );
};
